import type { ProductStyleId } from '@customink/project-service-react-components';
import {
  useConfigContext,
  useProduct,
} from '@customink/project-service-react-components';
import { useCallback } from 'react';

export function useSizingGuide(productId?: ProductStyleId) {
  const url = useConfigContext().sizesUrl;
  const { data: product } = useProduct({ colorId: productId });

  const normalizedProductId = product?.id_leading_zero
    ? '0' + productId
    : productId;

  const openSizingGuide = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (!productId) {
        return;
      }

      window.open(
        `${url}/${normalizedProductId}_lineup/standard.htm`,
        'window',
        'width=730height,height=790,scrollbars=yes,toolbar=yes,menubar=no,location=yes,resizable=yes',
      );
    },
    [url, normalizedProductId],
  );

  return { openSizingGuide };
}
